import React from 'react'
import { graphql } from 'gatsby'
import Seo from '../../components/seo'
import get from 'lodash/get'
import Layout from '../../components/layout'
import { Link, Typography } from '@material-ui/core'
import Pagination from '@material-ui/lab/Pagination'
import PaginationItem from '@material-ui/lab/PaginationItem'
import styles from './index.module.css'
import News from '../../components/news'
import BrandedHero from '../../components/branded-hero'
import InformationNews from '../../components/information-news'
import { isHealthContent } from '../../utils/content-categories'
import { getListArticles } from '../../utils/article-list'
import { mergeEditorialArticles } from '../../utils/editorial-articles'

class ListaArticoliTemplate extends React.Component {
  render() {
    const allArticles = get(
      this.props,
      'data.allContentfulArticolo.nodes'
    ).map((articolo) => articolo)
    const allVideos = get(
      this.props,
      'data.allContentfulVideo.nodes',
      []
    )
    const categoria = get(this.props, 'pageContext.categoria')
    const page = get(this.props, 'pageContext.page')
    const isHealthCategory = categoria === 'sanita'
    const filteredArticles = getListArticles(mergeEditorialArticles(allArticles, categoria), categoria)
    const articoliList = filteredArticles.slice((page - 1) * 12, page * 12)
    const videoList = allVideos.filter((video) => {
      if (isHealthCategory) return isHealthContent(video)
      if (isHealthContent(video)) return false
      if (!categoria) return true

      return (video.categorie || []).some(
        (videoCategory) => videoCategory.slug === categoria
      )
    })
    const pageTitle = `Movimento Rivoluzione Fiscale - Primo piano${
      categoria ? ` - ${categoria}` : ''
    }`
    const visibleTitle = categoria ? `Primo piano: ${categoria}` : 'Primo piano'

    const slug = get(this.props, 'pageContext.slug')
    const maxPages = Math.max(1, Math.ceil(filteredArticles.length / 12))
    const handleChange = (event, value) => {
      window.location.href = `/${slug}/${value}/`
    }

    return (
      <Layout location={this.props.location}>
        <Seo title={visibleTitle + (page > 1 ? ` · Pagina ${page}` : '')} description={`Notizie e approfondimenti MRF${categoria ? ' su ' + categoria : ''}, ordinati per data. Pagina ${page}.`} path={`/${slug}/${page}/`} noIndex={page > maxPages} />
        <div className={styles.container}>
          <div className={styles.gridContainer}>
            <div className={styles.titleContainer}>
                <Typography variant={'h2'} component="h1">{visibleTitle}</Typography>
                <Typography className={styles.intro}>
                  Notizie e approfondimenti MRF ordinati per data e presentati in schede separate.
                </Typography>
            </div>
            {page === 1 && !categoria && <InformationNews compact showAgencies />}
            {page === 1 && videoList.length > 0 && (
              <div className={styles.featuredBlock}>
                <News value={0} index={0} news={videoList.slice(0, 2)} />
              </div>
            )}
            <div className={styles.articleGrid}>
              {articoliList.map((articolo) => (
                <div
                  className={styles.articleGridItem}
                  key={`article-list-${articolo.id}`}
                >
                  <article className={styles.articleCard}>
                    <Link href={`/articoli/${articolo.slug}/`}>
                      <BrandedHero
                        className={styles.img}
                        alt={articolo.titolo}
                        src={articolo.heroImage.file.url}
                        brandingKey={articolo.slug}
                      />
                    </Link>
                    <div className={styles.articleText}>
                      <Link href={`/articoli/${articolo.slug}/`}>
                        <Typography variant={'h3'} className={styles.titleArticle}>
                          {articolo.titolo}
                        </Typography>
                      </Link>
                      {articolo.autore && (
                        <Typography variant={'subtitle1'} className={styles.author}>
                          {`${articolo.autore.nome} ${articolo.autore.cognome}, ${articolo.dataPubblicazione}`}
                        </Typography>
                      )}
                    </div>
                  </article>
                </div>
              ))}
            </div>
            <Pagination
              classes={{
                root: styles.paginationRoot,
              }}
              renderItem={(item) => (
                <PaginationItem
                  component={item.page && !item.disabled ? 'a' : 'button'}
                  href={item.page && !item.disabled ? `/${slug}/${item.page}/` : undefined}
                  classes={{
                    selected: styles.paginationItemSelected,
                  }}
                  {...item}
                />
              )}
              count={maxPages}
              page={page}
              onChange={handleChange}
              variant="outlined"
              shape="rounded"
            />
          </div>
        </div>
      </Layout>
    )
  }
}

export default ListaArticoliTemplate

export const pageQuery = graphql`
  query ArticoloList($categoriaRegex: String!) {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulVideo(
      filter: { slug: { ne: "non-eliminare" }, titolo: { ne: "NON ELIMINARE" } }
      sort: { fields: [dataPubblicazione], order: DESC }
      limit: 2
    ) {
      nodes {
        id
        slug
        titolo
        categorie {
          label
          slug
        }
        publishedAt: dataPubblicazione
          dataPubblicazione(formatString: "MMMM Do, YYYY")
        embed {
          embed
        }
        contenuto {
          childMarkdownRemark {
            html
          }
        }
      }
    }
    allContentfulArticolo(
      filter: { slug: { ne: "non-eliminare" }, titolo: { ne: "NON ELIMINARE" }, categorie: { elemMatch: { slug: { regex: $categoriaRegex } } } }
      sort: { fields: [dataPubblicazione], order: DESC }
    ) {
      nodes {
        id
        slug
        titolo
        categorie {
          label
        }
        contenuto {
          childMarkdownRemark {
            html
          }
        }
        autore {
          cognome
          nome
          descrizione
        }
        publishedAt: dataPubblicazione
          dataPubblicazione(formatString: "MMMM Do, YYYY")
        heroImage {
          file {
            url
          }
          fluid(maxWidth: 2400, quality: 100, background: "rgb:000000") {
            ...GatsbyContentfulFluid
          }
        }
      }
    }
  }
`


